const { deleteApp, initializeApp } = require('firebase/app');
const {
  getAuth,
  inMemoryPersistence,
  setPersistence,
  signInWithCustomToken
} = require('firebase/auth');
const { getFirestore } = require('firebase/firestore');

const firebaseConfig = {
  projectId: 'spassdaas',
  appId: '1:1036121994301:web:cae7c777dc9e1408d6e654',
  storageBucket: 'spassdaas.appspot.com',
  apiKey: 'AIzaSyCUoT3M4e-yHY3jYFCI841Roj1LpsVyJKA',
  authDomain: 'spassdaas.firebaseapp.com',
  messagingSenderId: '1036121994301'
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

async function startImpersonation(customToken) {
  const impersonationApp = initializeApp(firebaseConfig, `spache-impersonation-${Date.now()}`);
  const impersonationAuth = getAuth(impersonationApp);
  const impersonationDb = getFirestore(impersonationApp);
  await setPersistence(impersonationAuth, inMemoryPersistence);
  const credential = await signInWithCustomToken(impersonationAuth, customToken);

  return {
    app: impersonationApp,
    auth: impersonationAuth,
    db: impersonationDb,
    user: credential.user
  };
}

async function stopImpersonation(session) {
  await session.auth.signOut();
  await deleteApp(session.app);
}

module.exports = { auth, db, startImpersonation, stopImpersonation };
